import { AppRouteRecordRaw } from '../types';
import { ETranslationModule } from '@/i18n/translation';
import { Roles } from '@/constants/roles';

const Body = () => import('@/components/body.vue');
const FleetActivityLogs = () =>
  import('@/pages/fleetManagement/fleetOperations/FleetActivityLogs.vue');
const FleetSpendAnalytics = () =>
  import('@/pages/ryd-fleet-operations/analytics-and-commercial/fleet-spend-analytics/FleetSpendAnalytics.vue');
const FleetAnalyticsDashboard = () =>
  import('@/pages/ryd-fleet-operations/analytics-and-commercial/fleet-portfolio-analytics/FleetAnalyticsDashboard.vue');
const FleetPartnerList = () =>
  import('@/pages/ryd-fleet-operations/fleet-partner-management/partner-list/FleetPartnerList.vue');
const FleetPartnerCarPool = () =>
  import('@/pages/ryd-fleet-operations/fleet-partner-management/car-pool/FleetPartnerCarPool.vue');
const FleetPartnerVehicleAssignmentLog = () =>
  import('@/pages/ryd-fleet-operations/fleet-partner-management/car-pool/FleetPartnerVehicleAssignmentLog.vue');
const VehicleActivityLog = () =>
  import('@/pages/ryd-fleet-operations/fleet-partner-management/vehicle-activity-log/VehicleActivityLog.vue');
const FleetDriverManagement = () =>
  import('@/pages/ryd-fleet-operations/fleet-partner-management/drivers/FleetDriverManagement.vue');
const OrderManagement = () =>
  import('@/pages/ryd-fleet-operations/fleet-partner-management/orders/OrderManagement.vue');
const AddFleetDriversViaCsv = () =>
  import('@/pages/ryd-fleet-operations/fleet-partner-management/AddFleetDriversViaCsv.vue');
const FleetPartnerDetails = () =>
  import('@/pages/ryd-fleet-operations/fleet-partner-management/partner-details/FleetPartnerDetails.vue');
const CreateFleetPartner = () =>
  import('@/pages/fleetManagement/fleetAdministration/CreateFleetPartner.vue');
const FleetPartnerAudit = () =>
  import('@/pages/fleetManagement/fleetAdministration/FleetPartnerAudit.vue');
const FleetHpFormV2List = () =>
  import('@/pages/ryd-fleet-operations/acquisition-funnel/fleet-hp-form/FleetHpFormV2List.vue');
const FleetHpFormV2Details = () =>
  import('@/pages/ryd-fleet-operations/acquisition-funnel/fleet-hp-form/FleetHpFormV2Details.vue');
const FleetMarketingFunnelSessionsList = () =>
  import('@/pages/ryd-fleet-operations/acquisition-funnel/fleet-marketing-funnel/fleet-marketing-funnel-list/FleetMarketingFunnelSessionsList.vue');
const FleetMarketingFunnelSessionDetail = () =>
  import('@/pages/ryd-fleet-operations/acquisition-funnel/fleet-marketing-funnel/FleetMarketingFunnelSessionDetail.vue');
const FleetCheckoutOrdersList = () =>
  import('@/pages/ryd-fleet-operations/acquisition-funnel/fleet-checkout-orders/FleetCheckoutOrdersList.vue');
const FleetCheckoutOrderDetail = () =>
  import('@/pages/ryd-fleet-operations/acquisition-funnel/fleet-checkout-orders/FleetCheckoutOrderDetail.vue');
const FleetCheckoutOverview = () =>
  import('@/pages/ryd-fleet-operations/acquisition-funnel/fleet-checkout/overview/FleetCheckoutOverview.vue');
const FleetCheckoutHowItWorks = () =>
  import('@/pages/ryd-fleet-operations/acquisition-funnel/fleet-checkout/how-it-works/FleetCheckoutHowItWorks.vue');
const FleetCheckoutStatistics = () =>
  import('@/pages/ryd-fleet-operations/acquisition-funnel/fleet-checkout/statistics/FleetCheckoutStatistics.vue');
const FleetCheckoutSessionsList = () =>
  import('@/pages/ryd-fleet-operations/acquisition-funnel/fleet-checkout/sessions/FleetCheckoutSessionsList.vue');
const FleetCheckoutSessionDetail = () =>
  import('@/pages/ryd-fleet-operations/acquisition-funnel/fleet-checkout/sessions/FleetCheckoutSessionDetail.vue');
const FleetCheckoutCallbacksList = () =>
  import('@/pages/ryd-fleet-operations/acquisition-funnel/fleet-checkout/callbacks/FleetCheckoutCallbacksList.vue');
const FleetCheckoutCallbackDetail = () =>
  import('@/pages/ryd-fleet-operations/acquisition-funnel/fleet-checkout/callbacks/FleetCheckoutCallbackDetail.vue');
const FleetTempPw = () =>
  import('@/pages/ryd-fleet-operations/support-access/fleet-temp-pw/FleetTempPw.vue');
const FleetVirtualEmails = () =>
  import('@/pages/ryd-fleet-operations/support-access/fleet-virtual-emails/FleetVirtualEmails.vue');
const FleetVirtualEmailDetail = () =>
  import('@/pages/ryd-fleet-operations/support-access/fleet-virtual-email-detail/FleetVirtualEmailDetail.vue');
const BackofficeFleetPartnerList = () => import('@/pages/backoffice/fleet/FleetPartnerList.vue');
const FleetCardManager = () => import('@/pages/backoffice/fleet/FleetCardManager.vue');
const FleetCardCreator = () => import('@/pages/backoffice/fleet/FleetCardCreator.vue');
const FleetDrivers = () => import('@/pages/ryd-fleet-operations/admin-tools/FleetDrivers.vue');
const FleetLimits = () => import('@/pages/ryd-fleet-operations/admin-tools/FleetLimits.vue');
const FleetReports = () => import('@/pages/ryd-fleet-operations/admin-tools/FleetReports.vue');
const FleetTransactions = () =>
  import('@/pages/ryd-fleet-operations/admin-tools/FleetTransactions.vue');
const FleetVehicles = () => import('@/pages/ryd-fleet-operations/admin-tools/FleetVehicles.vue');
const FleetOperationsOverview = () =>
  import('@/pages/ryd-fleet-operations/overview/FleetOperationsOverview.vue');
const FleetSavingsCalculator = () =>
  import('@/pages/ryd-fleet-operations/savings-calculator/fleet-savings-calculator/FleetSavingsCalculator.vue');
const FleetSavingsCalculatorList = () =>
  import('@/pages/ryd-fleet-operations/savings-calculator/fleet-savings-calculator-list/FleetSavingsCalculatorList.vue');
const CountryPricingAdmin = () =>
  import('@/pages/ryd-fleet-operations/savings-calculator/admin/CountryPricingAdmin.vue');
const CalcSessionsList = () =>
  import('@/pages/ryd-fleet-operations/savings-calculator/sessions/CalcSessionsList.vue');
const CalcSessionDetail = () =>
  import('@/pages/ryd-fleet-operations/savings-calculator/sessions/CalcSessionDetail.vue');
const ContractToolWorkspace = () =>
  import('@/pages/ryd-fleet-operations/contract-tool/ContractToolWorkspace.vue');
const ContractToolList = () =>
  import('@/pages/ryd-fleet-operations/contract-tool/contract-tool-list/ContractToolList.vue');
const FleetCheckShell = () =>
  import('@/pages/ryd-fleet-operations/fleet-check/FleetCheckShell.vue');
const FleetCheckList = () =>
  import('@/pages/ryd-fleet-operations/fleet-check/fleet-check-list/FleetCheckList.vue');
const FleetCheckAnalysis = () =>
  import('@/pages/ryd-fleet-operations/fleet-check/fleet-check-analysis/FleetCheckAnalysis.vue');
const FleetCheckScanWorkspace = () =>
  import('@/pages/ryd-fleet-operations/fleet-check/scan/ScanWorkspace.vue');
const FleetCheckScanSavedList = () =>
  import('@/pages/ryd-fleet-operations/fleet-check/scan/ScanSavedList.vue');
const FleetCheckCasesTab = () =>
  import('@/pages/ryd-fleet-operations/fleet-check/tabs/CasesTab.vue');
const FleetCheckOutreachTab = () =>
  import('@/pages/ryd-fleet-operations/fleet-check/tabs/OutreachTab.vue');
const FleetCheckOnboardingTab = () =>
  import('@/pages/ryd-fleet-operations/fleet-check/tabs/OnboardingTab.vue');
const FleetCheckKalkulatorTab = () =>
  import('@/pages/ryd-fleet-operations/fleet-check/tabs/KalkulatorTab.vue');
const FleetCheckSettingsTab = () =>
  import('@/pages/ryd-fleet-operations/fleet-check/tabs/SettingsTab.vue');
const FleetOperationsKnowledgeBase = () =>
  import('@/pages/ryd-fleet-operations/knowledge-base/FleetOperationsKnowledgeBase.vue');
const FleetOperationsKnowledgeBillingCycles = () =>
  import('@/pages/ryd-fleet-operations/knowledge-base/FleetOperationsKnowledgeBillingCycles.vue');
const FleetOperationsKnowledgeOnboarding = () =>
  import('@/pages/ryd-fleet-operations/knowledge-base/FleetOperationsKnowledgeOnboarding.vue');
const FleetOperationsKnowledgeNfcReadiness = () =>
  import('@/pages/ryd-fleet-operations/knowledge-base/FleetOperationsKnowledgeNfcReadiness.vue');
const PartnerBillingList = () =>
  import('@/pages/ryd-fleet-operations/partner-billing/partner-billing-list/PartnerBillingList.vue');
const PartnerBillingDetail = () =>
  import('@/pages/ryd-fleet-operations/partner-billing/partner-billing-detail/PartnerBillingDetail.vue');
const PartnerBillingAnalytics = () =>
  import('@/pages/ryd-fleet-operations/partner-billing/partner-billing-analytics/PartnerBillingAnalytics.vue');
const FleetInvoiceDataHub = () =>
  import('@/pages/ryd-fleet-operations/partner-billing/fleet-invoice-data-hub/FleetInvoiceDataHub.vue');
const DriverCreationAudit = () =>
  import('@/pages/ryd-fleet-operations/driver-creation/DriverCreationAudit.vue');
const FleetPaymentMethodSwitch = () =>
  import('@/pages/ryd-fleet-operations/payment-transition/fleet-payment-method-switch/FleetPaymentMethodSwitch.vue');
const FleetSuspensionWorkspace = () =>
  import('@/pages/ryd-fleet-operations/fleet-suspension/FleetSuspensionWorkspace.vue');
const FleetSuspensionJourneyList = () =>
  import('@/pages/ryd-fleet-operations/fleet-suspension/FleetSuspensionJourneyList.vue');
const FleetSuspensionJourneyDetail = () =>
  import('@/pages/ryd-fleet-operations/fleet-suspension/FleetSuspensionJourneyDetail.vue');
const FleetPaymentTransitions = () =>
  import('@/pages/ryd-fleet-operations/payment-transition/fleet-payment-transitions/FleetPaymentTransitions.vue');
const FleetPaymentTransitionDetail = () =>
  import('@/pages/ryd-fleet-operations/payment-transition/fleet-payment-transition-detail/FleetPaymentTransitionDetail.vue');
const PayByInvoiceQueue = () =>
  import('@/pages/ryd-fleet-operations/pay-by-invoice/pay-by-invoice-queue/PayByInvoiceQueue.vue');
const PayByInvoiceJourneyDetail = () =>
  import('@/pages/ryd-fleet-operations/pay-by-invoice/pay-by-invoice-detail/PayByInvoiceJourneyDetail.vue');

// Partner fuel cards (BMW ARAL first): ryd Ops pages over rp-integrations /fuel-cards/ops/*.
const FuelCardOrders = () =>
  import('@/pages/ryd-fleet-operations/partner-fuel-cards/orders/FuelCardOrders.vue');
const FuelCardFiles = () =>
  import('@/pages/ryd-fleet-operations/partner-fuel-cards/files/FuelCardFiles.vue');
const FuelCardOpsQueue = () =>
  import('@/pages/ryd-fleet-operations/partner-fuel-cards/ops-queue/FuelCardOpsQueue.vue');
const FuelCardManualImport = () =>
  import('@/pages/ryd-fleet-operations/partner-fuel-cards/manual-import/FuelCardManualImport.vue');
const FuelCardPrograms = () =>
  import('@/pages/ryd-fleet-operations/partner-fuel-cards/programs/FuelCardPrograms.vue');
const FuelCardSftpBrowser = () =>
  import('@/pages/ryd-fleet-operations/partner-fuel-cards/sftp-browser/FuelCardSftpBrowser.vue');

export const rydFleetOperationsRoutes: AppRouteRecordRaw[] = [
  {
    path: '/fleet-operations',
    component: Body,
    meta: {
      requiresAuth: true,
      requiredUserGroup: ['ryd'],
      i18nModules: [ETranslationModule.fleet],
      breadcrumb: 'Fleet Operations',
    },
    children: [
      {
        path: '',
        redirect: '/fleet-operations/overview',
      },
      {
        path: 'overview',
        name: 'fleetOpsOverview',
        component: FleetOperationsOverview,
        meta: {
          title: 'Fleet Operations Overview | ryd Portal',
          breadcrumb: 'Overview',
        },
      },
      {
        path: 'knowledge-base',
        name: 'fleetOpsKnowledgeBase',
        component: FleetOperationsKnowledgeBase,
        meta: {
          title: 'Fleet Operations - Knowledge Base | ryd Portal',
          breadcrumb: 'Knowledge Base',
        },
      },
      {
        path: 'knowledge-base/billing-cycles',
        name: 'fleetOpsKnowledgeBillingCycles',
        component: FleetOperationsKnowledgeBillingCycles,
        meta: {
          title: 'Fleet Operations - Billing Cycles | ryd Portal',
          breadcrumb: 'Billing Cycles',
        },
      },
      {
        path: 'knowledge-base/fleet-partner-onboarding',
        name: 'fleetOpsKnowledgeOnboarding',
        component: FleetOperationsKnowledgeOnboarding,
        meta: {
          title: 'Fleet Operations - Fleet Partner Onboarding | ryd Portal',
          breadcrumb: 'Fleet Partner Onboarding',
        },
      },
      {
        path: 'knowledge-base/nfc-readiness',
        name: 'fleetOpsKnowledgeNfcReadiness',
        component: FleetOperationsKnowledgeNfcReadiness,
        meta: {
          title: 'Fleet Operations - NFC Readiness | ryd Portal',
          breadcrumb: 'NFC Readiness',
        },
      },
      {
        path: 'activity-logs',
        name: 'fleetOpsActivityLogs',
        component: FleetActivityLogs,
        meta: {
          title: 'Fleet Operations - Activity Logs | ryd Portal',
          breadcrumb: 'Fleet Activity Logs',
        },
      },
      {
        path: 'spend-analytics',
        name: 'fleetOpsSpendAnalytics',
        component: FleetSpendAnalytics,
        meta: {
          title: 'Fleet Operations - Spend Analytics | ryd Portal',
          breadcrumb: 'Spend Analytics',
        },
      },
      {
        path: 'analytics-dashboard',
        name: 'fleetOpsAnalyticsDashboard',
        component: FleetAnalyticsDashboard,
        meta: {
          title: 'Fleet Operations - Analytics Dashboard | ryd Portal',
        },
      },
      {
        path: 'partner-billing',
        name: 'partnerBillingList',
        component: PartnerBillingList,
        meta: {
          title: 'Partner Billing | ryd Portal',
          breadcrumb: 'Partner Billing',
        },
      },
      {
        path: 'partner-billing/analytics',
        name: 'partnerBillingAnalytics',
        component: PartnerBillingAnalytics,
        meta: {
          title: 'Partner Billing Analytics | ryd Portal',
          breadcrumb: 'Partner Billing Analytics',
        },
      },
      {
        path: 'partner-billing/fleet-invoice-data-hub',
        name: 'fleetInvoiceDataHub',
        component: FleetInvoiceDataHub,
        meta: {
          title: 'Fleet Invoice Data Hub | ryd Portal',
          breadcrumb: 'Fleet Invoice Data Hub',
        },
      },
      {
        path: 'partner-billing/:sponsorId',
        name: 'partnerBillingDetail',
        component: PartnerBillingDetail,
        meta: {
          title: 'Partner Billing Detail | ryd Portal',
          breadcrumb: 'Partner Billing Detail',
        },
      },
      {
        path: 'partner-list',
        name: 'fleetOpsPartnerList',
        component: FleetPartnerList,
        meta: {
          title: 'Fleet Operations - Partner List | ryd Portal',
          breadcrumb: 'Fleet Partner List',
        },
      },
      {
        path: 'partner-list/:sponsorId/car-pool',
        name: 'fleetOpsPartnerCarPool',
        component: FleetPartnerCarPool,
        meta: {
          title: 'Fleet Operations - Fleet Car Pool | ryd Portal',
          breadcrumb: 'Fleet Car Pool',
        },
      },
      {
        path: 'partner-list/:sponsorId/vehicle-assignment-log',
        name: 'fleetOpsPartnerVehicleAssignmentLog',
        component: FleetPartnerVehicleAssignmentLog,
        meta: {
          title: 'Fleet Operations - Vehicle Assignment Log | ryd Portal',
          breadcrumb: 'Vehicle Assignment Log',
        },
      },
      {
        path: 'partner-fuel-cards',
        redirect: '/fleet-operations/partner-fuel-cards/orders',
      },
      {
        path: 'partner-fuel-cards/orders',
        name: 'fleetOpsFuelCardOrders',
        component: FuelCardOrders,
        meta: {
          title: 'Fleet Operations - Fuel Card Orders | ryd Portal',
          breadcrumb: 'Fuel Card Orders',
          requiredRoles: [Roles.fuel_card_ops],
          strictRoles: true,
        },
      },
      {
        path: 'partner-fuel-cards/files',
        name: 'fleetOpsFuelCardFiles',
        component: FuelCardFiles,
        meta: {
          title: 'Fleet Operations - Fuel Card Provider Files | ryd Portal',
          breadcrumb: 'Fuel Card Provider Files',
          requiredRoles: [Roles.fuel_card_ops],
          strictRoles: true,
        },
      },
      {
        path: 'partner-fuel-cards/ops-queue',
        name: 'fleetOpsFuelCardOpsQueue',
        component: FuelCardOpsQueue,
        meta: {
          title: 'Fleet Operations - Fuel Card Ops Queue | ryd Portal',
          breadcrumb: 'Fuel Card Ops Queue',
          requiredRoles: [Roles.fuel_card_ops],
          strictRoles: true,
        },
      },
      {
        path: 'partner-fuel-cards/manual-import',
        name: 'fleetOpsFuelCardManualImport',
        component: FuelCardManualImport,
        meta: {
          title: 'Fleet Operations - Fuel Card Manual Import | ryd Portal',
          breadcrumb: 'Fuel Card Manual Import',
          requiredRoles: [Roles.fuel_card_ops],
          strictRoles: true,
        },
      },
      {
        // D-51: a subset of Ops; the menu, this guard and rp-integrations require both roles.
        path: 'partner-fuel-cards/sftp-files',
        name: 'fleetOpsFuelCardSftpFiles',
        component: FuelCardSftpBrowser,
        meta: {
          title: 'Fleet Operations - Fuel Card SFTP Files | ryd Portal',
          breadcrumb: 'Fuel Card SFTP Files',
          requiredRoles: [Roles.fuel_card_ops, Roles.fuel_card_sftp_viewer],
          strictRoles: true,
        },
      },
      {
        path: 'partner-fuel-cards/programs',
        name: 'fleetOpsFuelCardPrograms',
        component: FuelCardPrograms,
        meta: {
          title: 'Fleet Operations - Fuel Card Programs | ryd Portal',
          breadcrumb: 'Fuel Card Programs',
          requiredRoles: [Roles.fuel_card_ops],
          strictRoles: true,
        },
      },
      {
        path: 'vehicle-activity-log',
        name: 'fleetOpsVehicleActivityLog',
        component: VehicleActivityLog,
        meta: {
          title: 'Fleet Operations - Vehicle Activity Log | ryd Portal',
          breadcrumb: 'Vehicle Activity Log',
        },
      },
      {
        path: 'fleet-suspension',
        name: 'fleetOpsFleetSuspension',
        component: FleetSuspensionWorkspace,
        meta: {
          title: 'Fleet Operations - Block / Unblock Fleet | ryd Portal',
          breadcrumb: 'Block / Unblock Fleet',
        },
      },
      {
        path: 'fleet-suspension/journeys',
        name: 'fleetOpsFleetSuspensionJourneys',
        component: FleetSuspensionJourneyList,
        meta: {
          title: 'Fleet Operations - Suspension Journeys | ryd Portal',
          breadcrumb: 'Suspension Journeys',
        },
      },
      {
        path: 'fleet-suspension/journeys/:journeyId',
        name: 'fleetOpsFleetSuspensionJourney',
        component: FleetSuspensionJourneyDetail,
        meta: {
          title: 'Fleet Operations - Suspension Journey | ryd Portal',
          breadcrumb: 'Suspension Journey',
        },
      },
      {
        path: 'driver-management',
        name: 'fleetOpsDriverManagement',
        component: FleetDriverManagement,
        meta: {
          title: 'Fleet Operations - Driver Management | ryd Portal',
          breadcrumb: 'Driver Management',
        },
      },
      {
        path: 'order-management',
        name: 'fleetOpsOrderManagement',
        component: OrderManagement,
        meta: {
          title: 'Fleet Operations - Transaction Management | ryd Portal',
          breadcrumb: 'Transaction Management',
        },
      },
      {
        path: 'add-drivers-via-csv',
        name: 'fleetOpsAddDriversViaCsv',
        component: AddFleetDriversViaCsv,
        meta: {
          title: 'Fleet Operations - Add Drivers via CSV | ryd Portal',
          breadcrumb: 'Add Drivers via CSV',
        },
      },
      {
        path: 'how-to-onboard-a-fleet-partner',
        name: 'fleetOpsHowToOnboard',
        redirect: '/fleet-operations/knowledge-base/fleet-partner-onboarding',
        meta: {
          title: 'Fleet Operations - How To Onboard | ryd Portal',
          breadcrumb: 'How To Onboard a Fleet Partner',
        },
      },
      {
        path: 'partners/:id',
        name: 'fleetOpsPartnerDetails',
        component: FleetPartnerDetails,
        meta: {
          title: 'Fleet Operations - Partner Details | ryd Portal',
          breadcrumb: 'Fleet Partner Details',
        },
      },
      {
        path: 'create-partner',
        name: 'fleetOpsCreatePartner',
        component: CreateFleetPartner,
        meta: {
          title: 'Fleet Operations - Create Fleet Partner | ryd Portal',
          breadcrumb: 'Create Fleet Partner',
        },
      },
      {
        path: 'partner-audit',
        name: 'fleetOpsPartnerAudit',
        component: FleetPartnerAudit,
        meta: {
          title: 'Fleet Operations - Partner Audit | ryd Portal',
          breadcrumb: 'Fleet Partner Audit',
        },
      },
      {
        path: 'fleet-hp-form',
        name: 'fleetOpsHpFormV2List',
        component: FleetHpFormV2List,
        meta: {
          title: 'Fleet Operations - HP Form Submissions | ryd Portal',
          breadcrumb: 'Fleet HP Form Data',
        },
      },
      {
        path: 'fleet-hp-form/details/:id',
        name: 'fleetOpsHpFormV2Details',
        component: FleetHpFormV2Details,
        meta: {
          title: 'Fleet Operations - HP Form Submission | ryd Portal',
          breadcrumb: 'Fleet HP Form Submission',
        },
      },
      {
        path: 'fleet-marketing-funnel-sessions',
        name: 'fleetOpsFunnelSessionsList',
        component: FleetMarketingFunnelSessionsList,
        meta: {
          title: 'Fleet Operations - Funnel Sessions | ryd Portal',
          breadcrumb: 'Fleet Funnel Sessions',
        },
      },
      {
        path: 'fleet-marketing-funnel-sessions/:sessionId',
        name: 'fleetOpsFunnelSessionDetail',
        component: FleetMarketingFunnelSessionDetail,
        meta: {
          title: 'Fleet Operations - Funnel Session | ryd Portal',
          breadcrumb: 'Fleet Funnel Session',
        },
      },
      // D-36: a submitted checkout is a "signup order" (at ryd "order" = top-up / EV charge /
      // car wash). The old paths redirect so links in earlier ops mails keep working.
      {
        path: 'fleet-checkout/signup-orders',
        name: 'fleetOpsCheckoutOrdersList',
        component: FleetCheckoutOrdersList,
        meta: {
          title: 'Fleet Operations - Checkout Signup Orders | ryd Portal',
          breadcrumb: 'Fleet Checkout Signup Orders',
        },
      },
      {
        path: 'fleet-checkout/signup-orders/:orderId',
        name: 'fleetOpsCheckoutOrderDetail',
        component: FleetCheckoutOrderDetail,
        meta: {
          title: 'Fleet Operations - Checkout Signup Order | ryd Portal',
          breadcrumb: 'Fleet Checkout Signup Order',
        },
      },
      {
        path: 'fleet-checkout-orders',
        redirect: (to) => ({ name: 'fleetOpsCheckoutOrdersList', query: to.query }),
      },
      {
        path: 'fleet-checkout-orders/:orderId',
        redirect: (to) => ({
          name: 'fleetOpsCheckoutOrderDetail',
          params: { orderId: to.params.orderId },
          query: to.query,
        }),
      },
      {
        path: 'fleet-checkout',
        redirect: { name: 'fleetOpsCheckoutOverview' },
      },
      {
        path: 'fleet-checkout/overview',
        name: 'fleetOpsCheckoutOverview',
        component: FleetCheckoutOverview,
        meta: {
          title: 'Fleet Operations - Fleet Checkout (V5) Overview | ryd Portal',
          breadcrumb: 'Fleet Checkout Overview',
        },
      },
      {
        path: 'fleet-checkout/how-it-works',
        name: 'fleetOpsCheckoutHowItWorks',
        component: FleetCheckoutHowItWorks,
        meta: {
          title: 'Fleet Operations - How the Fleet Checkout Works | ryd Portal',
          breadcrumb: 'How the Fleet Checkout Works',
        },
      },
      {
        path: 'fleet-checkout/statistics',
        name: 'fleetOpsCheckoutStatistics',
        component: FleetCheckoutStatistics,
        meta: {
          title: 'Fleet Operations - Checkout Statistics | ryd Portal',
          breadcrumb: 'Fleet Checkout Statistics',
        },
      },
      {
        path: 'fleet-checkout/sessions',
        name: 'fleetOpsCheckoutSessionsList',
        component: FleetCheckoutSessionsList,
        meta: {
          title: 'Fleet Operations - Checkout Sessions | ryd Portal',
          breadcrumb: 'Fleet Checkout Sessions',
        },
      },
      {
        path: 'fleet-checkout/sessions/:sessionId',
        name: 'fleetOpsCheckoutSessionDetail',
        component: FleetCheckoutSessionDetail,
        meta: {
          title: 'Fleet Operations - Checkout Session | ryd Portal',
          breadcrumb: 'Fleet Checkout Session',
        },
      },
      {
        path: 'fleet-checkout/callbacks',
        name: 'fleetOpsCheckoutCallbacksList',
        component: FleetCheckoutCallbacksList,
        meta: {
          title: 'Fleet Operations - Checkout Callbacks | ryd Portal',
          breadcrumb: 'Fleet Checkout Callbacks',
        },
      },
      {
        path: 'fleet-checkout/callbacks/:callbackId',
        name: 'fleetOpsCheckoutCallbackDetail',
        component: FleetCheckoutCallbackDetail,
        meta: {
          title: 'Fleet Operations - Checkout Callback | ryd Portal',
          breadcrumb: 'Fleet Checkout Callback',
        },
      },
      {
        path: 'fleet-temp-pws',
        name: 'fleetOpsFleetTempPws',
        component: FleetTempPw,
        meta: {
          title: 'Fleet Operations - Temp Passwords | ryd Portal',
          breadcrumb: 'Fleet Temp Passwords',
        },
      },
      {
        path: 'fleet-virtual-emails',
        name: 'fleetOpsFleetVirtualEmails',
        component: FleetVirtualEmails,
        meta: {
          title: 'Fleet Operations - Virtual Emails | ryd Portal',
          breadcrumb: 'Fleet Virtual Emails',
        },
      },
      {
        path: 'fleet-virtual-emails/:id',
        name: 'fleetOpsFleetVirtualEmailDetail',
        component: FleetVirtualEmailDetail,
        meta: {
          title: 'Fleet Operations - Virtual Email Detail | ryd Portal',
          breadcrumb: 'Fleet Virtual Email Detail',
        },
      },
      {
        path: 'fleet-partner-overview',
        name: 'fleetOpsFleetPartnerOverview',
        component: BackofficeFleetPartnerList,
        meta: {
          title: 'Fleet Operations - Fleet Partner Overview | ryd Portal',
          breadcrumb: 'Fleet Partner Overview',
        },
      },
      {
        path: 'fleet-card-manager',
        name: 'fleetOpsFleetCardManager',
        component: FleetCardManager,
        meta: {
          title: 'Fleet Operations - Fleet Card Manager | ryd Portal',
          breadcrumb: 'Fleet Card Manager',
        },
      },
      {
        path: 'fleet-card-creator',
        name: 'fleetOpsFleetCardCreator',
        component: FleetCardCreator,
        meta: {
          title: 'Fleet Operations - Fleet Card Creator | ryd Portal',
          breadcrumb: 'Fleet Card Creator',
        },
      },
      {
        path: 'fleet-drivers',
        name: 'fleetOpsFleetDrivers',
        redirect: '/fleet-operations/driver-management',
      },
      {
        path: 'fleet-drivers/legacy',
        name: 'fleetOpsFleetDriversLegacy',
        component: FleetDrivers,
        meta: {
          title: 'Fleet Operations - Fleet Drivers | ryd Portal',
          breadcrumb: 'Fleet Drivers',
        },
      },
      {
        path: 'fleet-limits',
        name: 'fleetOpsFleetLimits',
        component: FleetLimits,
        meta: {
          title: 'Fleet Operations - Fleet Limits | ryd Portal',
          breadcrumb: 'Fleet Limits',
        },
      },
      {
        path: 'fleet-reports',
        name: 'fleetOpsFleetReports',
        component: FleetReports,
        meta: {
          title: 'Fleet Operations - Fleet Reports | ryd Portal',
          breadcrumb: 'Fleet Reports',
        },
      },
      {
        path: 'fleet-transactions',
        name: 'fleetOpsFleetTransactions',
        redirect: '/fleet-operations/order-management',
      },
      {
        path: 'fleet-transactions/legacy',
        name: 'fleetOpsFleetTransactionsLegacy',
        component: FleetTransactions,
        meta: {
          title: 'Fleet Operations - Fleet Transactions | ryd Portal',
          breadcrumb: 'Fleet Transactions',
        },
      },
      {
        path: 'fleet-vehicles',
        name: 'fleetOpsFleetVehicles',
        component: FleetVehicles,
        meta: {
          title: 'Fleet Operations - Fleet Vehicles | ryd Portal',
          breadcrumb: 'Fleet Vehicles',
        },
      },
      {
        path: 'savings-calculator',
        name: 'fleetOpsSavingsCalculator',
        component: FleetSavingsCalculator,
        meta: {
          title: 'Fleet Operations - Savings Calculator | ryd Portal',
          breadcrumb: 'Fleet Savings Calculator',
        },
      },
      {
        path: 'savings-calculator/saved',
        name: 'fleetOpsSavingsCalculatorList',
        component: FleetSavingsCalculatorList,
        meta: {
          title: 'Fleet Operations - Saved Calculations | ryd Portal',
          breadcrumb: 'Saved Calculations',
        },
      },
      {
        path: 'savings-calculator-sessions',
        name: 'fleetOpsCalcSessionsList',
        component: CalcSessionsList,
        meta: {
          title: 'Fleet Operations - Savings Calculator Sessions | ryd Portal',
          breadcrumb: 'Savings Calculator Sessions',
        },
      },
      {
        path: 'savings-calculator-sessions/:sessionId',
        name: 'fleetOpsCalcSessionDetail',
        component: CalcSessionDetail,
        meta: {
          title: 'Fleet Operations - Savings Calculator Session | ryd Portal',
          breadcrumb: 'Savings Calculator Session',
        },
      },
      {
        path: 'fleet-check',
        component: FleetCheckShell,
        meta: {
          title: 'Fleet Operations - Fleet Check | ryd Portal',
          breadcrumb: 'Fleet Check',
        },
        children: [
          { path: '', redirect: { name: 'fleetOpsFleetCheckScan' } },
          {
            path: 'scan',
            name: 'fleetOpsFleetCheckScan',
            component: FleetCheckScanWorkspace,
            meta: { breadcrumb: 'Quick Scan' },
          },
          {
            path: 'cases',
            name: 'fleetOpsFleetCheckCases',
            component: FleetCheckCasesTab,
            meta: { breadcrumb: 'Reference Cases' },
          },
          {
            path: 'outreach',
            name: 'fleetOpsFleetCheckOutreach',
            component: FleetCheckOutreachTab,
            meta: { breadcrumb: 'Pilot Outreach' },
          },
          {
            // Default Analyse view = a fresh analysis (provider selection),
            // mirroring the toolkit. Saved analyses live under /analyse/saved.
            path: 'analyse',
            name: 'fleetOpsFleetCheckNew',
            component: FleetCheckAnalysis,
            meta: { breadcrumb: 'Billing Analysis' },
          },
          {
            path: 'analyse/saved',
            name: 'fleetOpsFleetCheckList',
            component: FleetCheckList,
            meta: { breadcrumb: 'Saved Analyses' },
          },
          {
            path: 'analyse/:id',
            name: 'fleetOpsFleetCheckAnalysis',
            component: FleetCheckAnalysis,
            meta: { breadcrumb: 'Analysis' },
          },
          {
            path: 'onboarding',
            name: 'fleetOpsFleetCheckOnboarding',
            component: FleetCheckOnboardingTab,
            meta: { breadcrumb: 'Fleet Onboarding' },
          },
          {
            path: 'kalkulator',
            name: 'fleetOpsFleetCheckKalkulator',
            component: FleetCheckKalkulatorTab,
            meta: { breadcrumb: 'Price Calculator' },
          },
          {
            path: 'settings',
            name: 'fleetOpsFleetCheckSettings',
            component: FleetCheckSettingsTab,
            meta: { breadcrumb: 'Settings' },
          },
        ],
      },
      {
        path: 'contract-tool',
        name: 'fleetOpsContractTool',
        component: ContractToolWorkspace,
        meta: {
          title: 'Fleet Operations - Contract Tool | ryd Portal',
          breadcrumb: 'Contract Tool',
          requiredRoles: [Roles.fleet_operations_admin],
        },
      },
      {
        path: 'contract-tool/saved',
        name: 'fleetOpsContractToolList',
        component: ContractToolList,
        meta: {
          title: 'Fleet Operations - Saved Contracts | ryd Portal',
          breadcrumb: 'Saved Contracts',
          requiredRoles: [Roles.fleet_operations_admin],
        },
      },
      {
        path: 'contract-tool/:id',
        name: 'fleetOpsContractToolEdit',
        component: ContractToolWorkspace,
        meta: {
          title: 'Fleet Operations - Contract Tool | ryd Portal',
          breadcrumb: 'Contract',
          requiredRoles: [Roles.fleet_operations_admin],
        },
      },
      {
        path: 'fleet-check-saved-scans',
        name: 'fleetOpsFleetCheckSavedScans',
        component: FleetCheckScanSavedList,
        meta: {
          title: 'Fleet Operations - Saved Fleet Checks | ryd Portal',
          breadcrumb: 'Saved Fleet Checks',
        },
      },
      {
        path: 'driver-creation-audit',
        name: 'driverCreationAudit',
        component: DriverCreationAudit,
        meta: {
          title: 'Fleet Operations - Driver Creation Audit | ryd Portal',
          breadcrumb: 'Driver Creation Audit',
          headTitle: 'Driver Creation Audit',
        },
      },
      {
        path: 'switch-to-sepa',
        redirect: '/fleet-operations/payment-method-switch',
      },
      {
        path: 'payment-method-switch',
        name: 'fleetOpsPaymentMethodSwitch',
        component: FleetPaymentMethodSwitch,
        meta: {
          title: 'Fleet Operations - Payment Method Switch | ryd Portal',
          breadcrumb: 'Payment Method Switch',
        },
      },
      {
        path: 'payment-transitions',
        name: 'fleetOpsPaymentTransitions',
        component: FleetPaymentTransitions,
        meta: {
          title: 'Fleet Operations - Payment Transitions | ryd Portal',
          breadcrumb: 'Payment Transitions',
        },
      },
      {
        path: 'payment-transitions/:fleetId/:transitionId',
        name: 'fleetOpsPaymentTransitionDetail',
        component: FleetPaymentTransitionDetail,
        meta: {
          title: 'Fleet Operations - Payment Transition Detail | ryd Portal',
          breadcrumb: 'Transition Detail',
        },
      },
      {
        path: 'pay-by-invoice',
        name: 'fleetOpsPayByInvoiceRoot',
        redirect: { name: 'fleetOpsPayByInvoiceQueue' },
        meta: {
          breadcrumb: 'Pay by Invoice',
        },
        children: [
          {
            path: '',
            name: 'fleetOpsPayByInvoiceQueue',
            component: PayByInvoiceQueue,
            meta: {
              title: 'Fleet Operations - Pay by Invoice | ryd Portal',
            },
          },
          {
            path: ':journeyId',
            name: 'fleetOpsPayByInvoiceDetail',
            component: PayByInvoiceJourneyDetail,
            meta: {
              title: 'Fleet Operations - Pay by Invoice Journey | ryd Portal',
              breadcrumb: 'Journey Detail',
            },
          },
        ],
      },
      {
        path: 'savings-calculator/admin/country-pricing',
        name: 'fleetOpsSavingsCalculatorCountryPricingAdmin',
        component: CountryPricingAdmin,
        meta: {
          title: 'Fleet Operations - Country Pricing Admin | ryd Portal',
          breadcrumb: 'Country Pricing Admin',
        },
      },
    ],
  },
];
